module.exports = __webpack_public_path__ + "media/thumbnail.d14562e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/outSide/assets/img/thumbnail.jpg
// module id = ./src/templates/outSide/assets/img/thumbnail.jpg
// module chunks = 0